
<template>
	<div ref="listWrap">
		<wrapper-list 
		    @add="paasAddPage"
        @calculate="paasCalculate"      
		    ref="wrapperList" >
      	<Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
          <row class="list-query-row">
            <FormItem label="分类" class="list-query-item" v-clickoutside="handlectitleClose">
              <Input v-model="queryParam.ctitle" @on-focus="changectitleFlag"
                     @on-clear="clearctitle" clearable  readonly="readonly"  style="width:300px;"></Input>
              <select-tree @selected-tree-value="updatectitleTreeNode"
                           serviceUrl='/eb/article/category'
                           v-show="showctitleTree"/>
            </FormItem>
            <FormItem label="文章标题" class="list-query-item">
              <Input  v-model="queryParam.query_LIKE_name" placeholder=""
                      @on-change="queryTableDatas" clearable  style="width:300px;"/>
            </FormItem>

          </row>
          <row class="list-query-row">
              <FormItem label="是否热点:" class="list-query-item">
                  <Enum :enumJsonKey="'crmdict-yesOrNo'"  v-model="queryParam.query_EQ_isHot"
                        @on-change="queryTableDatas" type="radio">
                  </Enum>
              </FormItem>
          </row>
        </Form>
      	<Table slot="table" stripe border :height="tableHeight"
             :data="tableData"
             :columns="tableColumns"
             @on-selection-change="selectTableDataChange"
             @on-sort-change="sortTableData"
             :no-data-text="noDataText">
        </Table>
        <Page slot="page"  :total="totalRecords"
              show-total show-sizer
              @on-change="changePage"
              @on-page-size-change="changePageSize">
        </Page>
      </wrapper-list>
   </div>
</template>
<script>
	  import wrapperList from "@/components/paas/wrapper-list";
    import metaList from "@/assets/js/list/meta-list.js";
    import CellBar from '@/components/paas/cell-bar' //列表内操作
    import SelectTree from '@/components/paas/selectTree'; //下拉树查询
    import Enum from '../../../components/paas/query-enum' //枚举查询
    export default {
      name: "list",
      mixins: [ metaList ],
      components: { wrapperList,CellBar ,SelectTree,Enum},
      data() {
      	return {
      		serviceUrl:"/eb/article",  //每个页面访问后台服务器的路径
      		currentIdFiledName: 'id',
            showctitleTree:false,
      		queryParam:{
                queryOrderBy_: 'createTime@desc',
                query_IN_cid:'',
                ctitle:'',
                query_LIKE_name:'',
                query_EQ_isHot:'',
	        },
	         defaultLabelWidth:200,
	         tableColumns:[
	        	{
	              type: 'index',  //type: 'index'，可以排序
	              width: 40,
	              align: 'center',
	          },
	        	{
	        		title: '文章图片',
	        		key: 'imageInput',
                    width:80,
                    render:(h,params)=>{
                        if(params.row.imageInput){
                          return h('img',{
                            attrs: {
                              src: params.row.imageInput,
                            },
                            style:{
                              width:"45px",
                              height:"45px"
                            }
                          })
                        }
                   }
	        	},
	        	{
	        		title: '文章标题',
	        		key: 'name',
	        	},
	        	{
	        		title: '浏览次数',
	        		key: 'visit',
                    width:80,
	        	},
	        	{
	        		title: '添加时间',
	        		key: 'createTime',
                    width:150,
	        	},
	        	{	
	        		title: '操作',
                    width:300,
	        		render: (h, params) => {
		                return h(CellBar,
		                    {
			                  props:{
			                    show:'textIcon'  //操作也显示标准按钮的样式（text、icon、textIcon）
			                  },
			                  //自定义事件监听器“on”,不支持如v-on:keyup.enter的修饰符，需要手动匹配keyCode
			                    on: {
			                      // 子组件$emit传递函数,必须是箭头函数写法
			                      'edit': ()=> {
			                        this.$nextTick(()=>{
			                          this.paasEditOper(params.row[this.currentIdFiledName]);
			                        })
			                      },
			                      'delete':()=>{
			                        this.$nextTick(()=>{
			                          this.paasDeleteOper(params.row[this.currentIdFiledName]);
			                        })
			                      },
			                    }
			                }
			            )
		            }
		         }
	        ],
      	}
      },
      mounted(){
      },
      methods:{
        handlectitleClose(){
          this.showctitleTree = false;
        },
        clearctitle(){
          this.queryParam.query_IN_cid = "";
          this.queryTableDatas();
        },
        updatectitleTreeNode(node){
          this.queryParam.ctitle = node.title;
          let childrenIds = node.id;
          for(let i = 0; i < node.children.length; i++){
            if(childrenIds) {
              childrenIds += ",";
            }
            childrenIds += node.children[i].id;
          }
          this.queryParam.query_IN_cid = childrenIds;
          this.queryTableDatas();
          this.showctitleTree = false;
        },
        changectitleFlag(){
          this.showctitleTree = true;
        }
      }
    } 
</script>
